import { useTranslation } from '@/shared/hooks/useTranslation'
import { Button } from '@/shared/ui/Button'

import type { Quest } from '../model/types'

type QuestWelcomeStepProps = {
  quest: Quest
  onStart: () => void
}

export function QuestWelcomeStep({ quest, onStart }: QuestWelcomeStepProps) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col items-center gap-4 text-center">
      <p className="m-0 text-lg font-bold text-gray-900">{quest.name}</p>
      {quest.description && <p className="m-0 text-sm text-gray-600">{quest.description}</p>}
      <Button variant="primary" size="lg" onClick={onStart}>
        {t('quests.welcome.start')}
      </Button>
    </div>
  )
}
